const experienceModules = document.querySelectorAll('.experience-module');

if (experienceModules.length > 0) {
  experienceModules.forEach((element) => {
    let controllerExperienceModule = null;
    controllerExperienceModule = new ScrollMagic.Controller();
    const mainParent = element.closest('.sc-experience-module');
    const stickyStart = mainParent.querySelector('.experience-module__sticky-start');
    const stickyElement = mainParent.querySelector('.experience-module__sticky-body');
    const fakeSlidesWrapper = mainParent.querySelector('.experience-module__faker-slides');
    const imageItems = mainParent.querySelectorAll('.experience-module__image');
    const scrollContainer = mainParent.querySelector('.experience-module__images');
    const fakeScrollItems = mainParent.querySelectorAll('.experience-module__faker-slides-scroll');
    const pagination = mainParent.querySelector('.slider-pagination');
    const paginationBullet = mainParent.querySelectorAll('.slider-pagination__bullet');
    const scrollContainerParent = mainParent.querySelector('.experience-module__images-scroll');

    const togglePrevClass = (element, toggle) => {
      element.classList.toggle('is-prev', toggle);
    };

    const toggleClasses = (item, targetContent, toggle) => {
      toggleActiveClass(item, toggle);
      toggleActiveClass(targetContent, toggle);
      togglePrevClass(targetContent, false);
    };

    // ----
    // Sticky scene
    // ----

    const stickyDuration = fakeSlidesWrapper.offsetHeight;
    const initStickyElementScene = () => {
      const moveImages = new TimelineMax();
      moveImages.to(scrollContainerParent, 1, { y: '-30%', ease: Power1.easeInOut });

      const scene = new ScrollMagic.Scene({
        triggerElement: stickyStart,
        duration: stickyDuration,
        triggerHook: 0,
      })
        .on('enter', () => {
          toggleActiveClass(paginationBullet[0], true);
          pagination.classList.add('is-visible');
        })
        .on('leave', () => {
          pagination.classList.remove('is-visible');
        })
        .setTween(moveImages)
        .setPin(stickyElement)
        .addTo(controllerExperienceModule);

      if (isLocal()) {
        scene.addIndicators({ name: 'Sticky' });
      }
    };

    // ----
    // Each slide scene
    // ----
    const eachSlideScene = () => {
      setTimeout(() => {
        // Used timeout because homepage video takes sometime to update it's height on scroll
        fakeScrollItems.forEach((item, i) => {
          const scrollValue = item.getAttribute('data-scroll');
          const itemIndex = parseInt(item.getAttribute('data-image'), 10);
          const targetContent = element.querySelector(`[data-content="${itemIndex}"]`);
          const prevTargetContent = element.querySelector(`[data-content="${itemIndex - 1}"]`);
          const nextTargetContent = element.querySelector(`[data-content="${itemIndex + 1}"]`);

          const slideAnimation = new TimelineMax();

          const scene = new ScrollMagic.Scene({
            triggerElement: item,
            duration: item.offsetHeight,
            triggerHook: 0,
          })
            .on('enter', (e) => {
              const activeItems = element.querySelectorAll('.is-active');
              toggleActiveClass(paginationBullet[i], true);
              removeActiveClass(activeItems);

              if (e.scrollDirection === 'FORWARD' && prevTargetContent) {
                togglePrevClass(prevTargetContent, true);
              }

              if (e.scrollDirection === 'REVERSE' && nextTargetContent) {
                togglePrevClass(nextTargetContent, false);
              }

              toggleClasses(item, targetContent, true);
              imageItems[i].classList.add('is-active');

              slideAnimation.to(scrollContainer, {
                y: `-${scrollValue}%`,
                duration: 0.6,
                ease: Power1.easeInOut,
              });
            })
            .on('leave', () => {
              toggleActiveClass(paginationBullet[i], false);
            })
            .addTo(controllerExperienceModule);

          if (isLocal()) {
            scene.addIndicators({ name: `slide ${i}` });
          }
        });
      }, 200);
    };

    // ----
    // Init All scene
    // ----
    const initAllScenes = () => {
      initStickyElementScene();
      eachSlideScene();
    };

    // ----
    // Destroy for mobile
    // ----
    const handleResize = () => {
      initializeOrDestroyScrollMagic(controllerExperienceModule, initAllScenes);
    };

    if (windowWidth() >= breakpointMd) {
      initAllScenes();
    }

    window.addEventListener('resize', handleResize);

    // Play video animation on scroll
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(async (entry) => {
          if (entry.intersectionRatio > 0) {
            try {
              await entry.target.play();
              entry.target.play();
            } catch (e) {
              console.error(error);
            }
          }
        });
      },
      { threshold: 1 },
    );

    // Load videos on first scroll
    const videos = document.querySelectorAll('.experience-module video');
    const loadVideosOnScroll = () => {
      const videoLazyLoaded = document.body.classList.contains('videos-loaded');
      if (!videoLazyLoaded) {
        videos.forEach(async (video) => {
          observer.observe(video);

          try {
            await video.play();
            video.pause();
          } catch (e) {
            console.error(error);
          }
        });
        document.body.classList.add('videos-loaded');
      }
    };

    loadVideosOnScroll();

    window.addEventListener(
      'scroll',
      () => {
        loadVideosOnScroll();
      },
      false,
    );
  });

  const experienceSlider = document.querySelectorAll('[data-slider="experience-module__slider"]');

  const experienceSliderOptions = {
    slidesPerView: 1,
    spaceBetween: 12,
    speed: 300,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  };

  experienceSlider.forEach((el) => {
    const experienceSliderParent = el.closest('.experience-module');
    const paginationElement = experienceSliderParent.querySelector('.swiper-pagination');

    const arrowRight = experienceSliderParent.querySelector('.arrow-right');
    const arrowLeft = experienceSliderParent.querySelector('.arrow-left');
    experienceSliderOptions.pagination.el = paginationElement;

    experienceSliderOptions.navigation.nextEl = arrowRight;
    experienceSliderOptions.navigation.prevEl = arrowLeft;

    new Swiper(el, experienceSliderOptions);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const backgroundVideos = document.querySelectorAll('[data-background-video]');
  backgroundVideos.forEach((video) => {
    const parentElem = video.closest('.sc-general');
    const promise = video.play();

    if (promise !== undefined) {
      promise
        .catch((error) => {
          // Auto-play was prevented
          // Show a UI element to let the user manually start playback
          if (error.name === 'NotAllowedError') {
            parentElem.classList.add('low-power-mode');
          }
        })
        .then(() => {
          // if there is no error, then we play the video
          video.play();
        });
    }
  });
});
